import { Subject } from 'rxjs/Subject';
var AbstractDestructionSubject = /** @class */ (function () {
    function AbstractDestructionSubject() {
        this.destroySubject$ = new Subject();
    }
    AbstractDestructionSubject.prototype.ngOnDestroy = function () {
        this.destroySubject$.next();
        this.destroySubject$.complete();
    };
    return AbstractDestructionSubject;
}());
export { AbstractDestructionSubject };
//# sourceMappingURL=abstract-destruction-subject.js.map